export default __webpack_public_path__ + "static/aboutUsImageResponsive-8efc9f6afaabccd06b1dce6c71475713.webp";